// import runActionsApi from '../../../../api/actions'

import getCookieParam from '../../../../lib/utils/getCookieParam'

const runActions = async (
  api: Object,
  actions: string[],
  requestData: any,
  inputs: string[],
  lff_uid?: string | null,
) => {
  // await new Promise((res) => setTimeout(res, 500))
  // console.log(actions[0], requestData)
  // return {status: true}

  console.log({ ...requestData })
  if (Array.isArray(actions)) {
    let result
    for (const action of actions) {
      console.log(action)
      let newRequestData: any = {}
      const keys = Object.keys(requestData)
      for (const name of keys) {
        if (requestData[name] !== "" && requestData[name] !== null) {
          newRequestData[name] = requestData[name]
          //для geo_zip от 1001 до 9999
          if (name === 'geo_zip' && String(requestData[name]).length < 5) {
            newRequestData[name] = '0' + requestData[name]
          }
          if (name === 'bank_account') {
            newRequestData[name] = requestData[name].replace(/\s/g, "")
          }
        }
      }
      console.log({ ...newRequestData })

      let apiData
      if (action === 'create') {
        apiData = newRequestData
      }
      if (action === 'update') {
        console.log({...inputs})
        const updateReqData: any = {}
        inputs.forEach(item => {
          updateReqData[item] = newRequestData[item]
        })
        console.log('updateReqData', updateReqData)
        apiData = updateReqData
      }
      // return {status: true, lff_uid: '123'}
      //@ts-ignore
     
      const data = await api[action](apiData, lff_uid)
      console.log(data)
      if (data || !data.status) {
        return data
        break;
      } else {
        result = data
      }
      // return {status: true, lff_uid: '123'}
    }
    return result
  } else {
    //@ts-ignore
    const { data } = await api[action](requestData)
    return data
    return { status: true, lff_uid: '123' }
  }
}

export default runActions